import { useTranslation } from "react-i18next";

import { useIsNationalSite } from "../../stores/hooks/useIsNationalSite";
import { isNationalReferrer } from "../../util/isNationalReferrer";
import { HeaderLink } from "./useHeaderLinks";

export const useNationalLink = (): HeaderLink | null => {
  const { t } = useTranslation();
  const referrer = document.referrer;
  const isNationalSite = useIsNationalSite();

  if (!isNationalSite && isNationalReferrer()) {
    const nationalLink: HeaderLink = {
      href: referrer,
      name: t("siteHeader.nationalSite"),
    };
    return nationalLink;
  }
  return null;
};
